module.exports = __webpack_public_path__ + "static/media/ReferAFriend.2cbb5ae7.svg";